import React, { Component } from 'react';
import { connect } from 'react-redux';

import {displacementTypes, seismicParams} from '../../misc/seismic.class';
import './styles.scss';

import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';
import { APP_TEXTS } from '../../../../../../texts/texts';
import { APP_TOOLTIPS } from '../../../../../../texts/tooltips';
import { Tooltip } from '@components/Tippy';

class LimitingDisplacement extends Component {

  state = {
    displacement: displacementTypes.ETA
  };

  render() {
    const { combination: { extraField = {} } } = this.props;

    if (!extraField[seismicParams.DISPLACEMENT]) {
      extraField[seismicParams.DISPLACEMENT] = this.state.displacement;
    }

    return (
      <section className="list-type limiting-displacement">
        <h4>{APP_TEXTS.LIMITING_DISPLACEMENT.Content}</h4>
        <Tooltip content={APP_TOOLTIPS.TOOLTIP_SEISMIC_LIMITING_DISPLACEMENT.Content}>
          <React.Fragment>
            <div className="radio-group">
              <label htmlFor="eta">
                <input
                  id="eta"
                  type="radio"
                  name={seismicParams.DISPLACEMENT}
                  value={displacementTypes.ETA}
                  onChange={() => {
                    this.props.onUpdate(displacementTypes.ETA, seismicParams.DISPLACEMENT);
                    this.setState({
                      displacement: displacementTypes.ETA
                    });
                  }}
                  defaultChecked={extraField[seismicParams.DISPLACEMENT] === displacementTypes.ETA}
                />
                <span>&nbsp;{APP_TEXTS.DISPLACEMENT_VALUES_FOR_DAMAGE_LIMITATION.Content}</span>
              </label>
              <label htmlFor="custom">
                <input
                  id="custom"
                  type="radio"
                  name={seismicParams.DISPLACEMENT}
                  value={displacementTypes.CUSTOM}
                  onChange={() => {
                    this.props.onUpdate(displacementTypes.CUSTOM, seismicParams.DISPLACEMENT);
                    this.setState({
                      displacement: displacementTypes.CUSTOM
                    });
                  }}
                  defaultChecked={extraField[seismicParams.DISPLACEMENT] === displacementTypes.CUSTOM}
                />
                <span>&nbsp;{APP_TEXTS.DISPLACEMENT_VALUES_FOR_DAMAGE.Content}</span>
              </label>
            </div>

            <div className={extraField[seismicParams.DISPLACEMENT] === displacementTypes.ETA ? 'limiting__row inactive' : 'limiting__row'}>
              <label htmlFor="tension">
                <span>{APP_TEXTS.DLS_TENSION.Content}&nbsp;</span>
                <input
                  className="form-control"
                  id="tension"
                  type="number"
                  lang="fr"
                  name="tension"
                  defaultValue={
                    unitTransform(+extraField[seismicParams.DISPLACEMENT_VALUE_TENSION] || 0)
                      .from(defaultUnits.DISTANCE)
                      .to(this.props.unit)
                  }
                  onChange={e => {
                    this.props.onUpdate(
                      unitTransform(+e.target.value, false).from(this.props.unit).to(defaultUnits.DISTANCE),
                      seismicParams.DISPLACEMENT_VALUE_TENSION
                    );
                  }}
                  disabled={extraField[seismicParams.DISPLACEMENT] === displacementTypes.ETA}
                />
                <span>{unitLabel(this.props.unit)}</span>
              </label>

              <label htmlFor="shear">
                <span>{APP_TEXTS.DLS_SHEAR.Content}&nbsp;</span>
                <input
                  className="form-control"
                  id="shear"
                  type="number"
                  lang="fr"
                  name="shear"
                  defaultValue={
                    unitTransform(+extraField[seismicParams.DISPLACEMENT_VALUE_SHEAR] || 0)
                      .from(defaultUnits.DISTANCE)
                      .to(this.props.unit)
                  }
                  onChange={e => {
                    this.props.onUpdate(
                      unitTransform(+e.target.value, false).from(this.props.unit).to(defaultUnits.DISTANCE),
                      seismicParams.DISPLACEMENT_VALUE_SHEAR
                    );
                  }}
                  disabled={extraField[seismicParams.DISPLACEMENT] === displacementTypes.ETA}
                />
                <span>{unitLabel(this.props.unit)}</span>
              </label>
            </div>
          </React.Fragment>
        </Tooltip>
      </section>
    );
  }

}

const mapState = state => ({
  unit: state.main.units.distance
});

export default connect(mapState)(LimitingDisplacement);



// WEBPACK FOOTER //
// ./src/views/Loads/GeneralLoading/DesignLoading/SeismicLoads/LimitingDisplacement/index.js